// import action types
import { USER_LOGGED_IN, CLEAR_USER_SESSION } from 'constants/redux-events';
import { IS_USER_LOGGED_IN } from 'constants/common';
import { cloneDeep } from 'lodash';

/********************************************************/

/**
 * @type {function}
 * @desc A Redux Reducer to manage state of the Redux Store
 * @param {object} [state={}] - Current state of the Redux Store at given state key
 * @param {object} action - Redux **action** object with **event name** and **payload**
 * @example
 * import { userLoggedIn } from 'reducers/userLoggedIn';
 */
export const userLoggedIn = ( state = { [ IS_USER_LOGGED_IN ]: undefined }, action ) => {
    const { type } = action;

    switch( type ) {
        case USER_LOGGED_IN: {
			const _state = cloneDeep( state );
			_state.isUserLoggedIn = true;
            return _state;
		}

		case CLEAR_USER_SESSION: {
			const _state = cloneDeep( state );
			_state.isUserLoggedIn = false;
            return _state;
		}
        default:
            return state;
    }
};
